var ARSnackbar = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ar-snackbar', _vm.type],attrs:{"ar-widget-id":"ar-snackbar","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-snackbar"}},[_c('ar-icon',{attrs:{"name":_vm.iconNameMap[_vm.type],"color":_vm.colorMap[_vm.type]}}),_vm._v(" "),_c('div',{class:['ar-snackbar-text-section', _vm.hasClearIcon && 'u-margin-right-5']},[_c('ar-text',{style:({
        color: _vm.hasTextColor ? _vm.colorMap[_vm.type] : _vm.$arStyle.color.blueGrey800,
      }),attrs:{"size":"xs","text":_vm.message,"allow-html":"","multiple-lines":"","weight":"bold","line-height":"18px","anchor-color":_vm.colorMap[_vm.type]},on:{"anchorClick":_vm.handleAnchorClick}})],1),_vm._v(" "),(_vm.hasClearIcon)?_c('ar-icon-button',{staticClass:"ar-snack-clear-icon",attrs:{"color":_vm.iconButtonColorMap[_vm.type],"hovered-color":_vm.iconButtonHoveredColorMap[_vm.type],"icon-props":{
      name: 'cross',
      height: '12px',
    }},on:{"click":_vm.handleClearIconClick}}):_vm._e()],1)},
staticRenderFns: [],
  name: 'Snackbar',
  props: {
    arWidgetMeta: String,
    type: {
      type: String,
      default: 'success',
      validator: (value) =>
        ['success', 'error', 'warning', 'general'].indexOf(value) !== -1,
    },
    message: {
      type: String,
      default: null,
    },
    hasTextColor: {
      type: Boolean,
      default: false,
    },
    hasClearIcon: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      iconNameMap: {
        success: 'notification-success',
        error: 'notification-error',
        warning: 'notification-warning',
        general: 'notification-general',
      },
      colorMap: {
        success: this.$arStyle.color.green500,
        error: this.$arStyle.color.red500,
        warning: this.$arStyle.color.orange500,
        general: this.$arStyle.color.purple500,
      },
      iconButtonColorMap: {
        success: this.$arStyle.color.green500,
        error: this.$arStyle.color.red500,
        warning: this.$arStyle.color.orange500,
        general: this.$arStyle.color.purple500,
      },
      iconButtonHoveredColorMap: {
        success: this.$arStyle.color.green500,
        error: this.$arStyle.color.red600,
        warning: this.$arStyle.color.orange500,
        general: this.$arStyle.color.purple600,
      },
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `text=${this.message};`,
        `type=${this.type};`,
      ].join('');
    },
  },
  methods: {
    handleAnchorClick(anchorIndex) {
      this.$emit('anchorClick', anchorIndex);
    },
    handleClearIconClick() {
      this.$emit('clear');
    },
  },
};

export default ARSnackbar;
